import { DEFAULT_LOCALE } from '@/constants/app';
import { i18n } from '@lingui/core';

export async function loadCatalog(locale: string) {
  const { messages } = await import(`./catalogs/${locale}.mjs`);

  return i18n.loadAndActivate({ locale, messages });
}

/**
 * Get the locale returned by the root route loader under the `locale` key.
 * @example
 * let locale = useLocale()
 * let formattedDate = date.toLocaleDateString(locale);
 * @example
 * let locale = useLocale("language")
 * let formattedDate = date.toLocaleDateString(locale);
 */
export function useLocale(localeKey = 'locale'): string {
  return DEFAULT_LOCALE;
}
